import React from "react";
import { message } from "antd";
import { LayoutContent, SEO, ThemeConfigForm } from "../../../components";
import { Images } from "../../../common/images";
import { LocalStorage } from "../../../modules/LocalStorage";
import { BootstrapUsecase } from "../../../usecases/Bootstrap/usecase";
import {
  ThemeConfig as ThemeConfigParam,
  ThemeConfigure,
} from "../../../config/theme-configure";

export const ThemeConfig: React.FC = () => {
  const tenantInfo = LocalStorage.getTenantInfo();
  const [loading, setLoading] = React.useState<boolean>(false);

  const onSaveHandle = async (values: ThemeConfigParam) => {
    if (!tenantInfo?.tenantId) {
      message.error("Missing tenant information");
      return;
    }

    setLoading(true);
    try {
      const updated = await new BootstrapUsecase().update({
        tenantId: tenantInfo.tenantId,
        themeConfig: values,
      });

      LocalStorage.setTenantInfo({ ...tenantInfo, ...updated });
      ThemeConfigure.apply(updated.themeConfig ?? values);
      message.success("Theme config saved");
    } catch (error) {
      message.error("Failed to save theme config");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LayoutContent title="Theme Config" iconPath={Images.SETTING_DE}>
      <SEO title="Theme Config" />
      <ThemeConfigForm
        initialValues={tenantInfo?.themeConfig}
        onSave={onSaveHandle}
        loading={loading}
      />
    </LayoutContent>
  );
};
